"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _hooks = require("../../utils/hooks");
var _globalComponentsLibrary = require("global-components-library");
require("./DragAndDropFile.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DragAndDropFile = function DragAndDropFile(_ref) {
  var className = _ref.className,
    onChange = _ref.onChange,
    onDragLeaveEnd = _ref.onDragLeaveEnd,
    mediaType = _ref.mediaType,
    maxImgToSend = _ref.maxImgToSend;
  var _useTranslation = (0, _reactI18next.useTranslation)('chat'),
    t = _useTranslation.t;
  var _useError = (0, _hooks.useError)(),
    _useError2 = _slicedToArray(_useError, 3),
    error = _useError2[0],
    showError = _useError2[1],
    toggleError = _useError2[2];
  var getFiles = (0, _hooks.useFileHandler)(mediaType, maxImgToSend, showError);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoad = _useState2[0],
    setIsLoad = _useState2[1];
  var _onDrop = function onDrop(e) {
    e.preventDefault();
    setIsLoad(true);
    try {
      onChange(getFiles(e.dataTransfer.files));
    } catch (_unused) {
      onDragLeaveEnd();
      setIsLoad(false);
    }
  };
  var _onDragLeave = function onDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    onDragLeaveEnd();
  };
  var onToggleError = function onToggleError() {
    onDragLeaveEnd();
    setIsLoad(false);
    toggleError();
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-drag-area' + (isLoad ? ' loading' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'image-upload-wrap ' + className,
    onDrop: function onDrop(e) {
      return _onDrop(e);
    },
    onDragLeave: function onDragLeave(e) {
      return _onDragLeave(e);
    }
  }, isLoad && /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    color: "primary"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-information"
  }, isLoad ? "".concat(t('loading'), "...") : t('drop-file'))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, _extends({}, error, {
    toggle: onToggleError,
    accept: t('errorFormat.attachErrorCommit')
  })));
};
DragAndDropFile.defaultProps = {
  className: ''
};
var _default = exports["default"] = DragAndDropFile;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/DragAndDrop/DragAndDropFile.js
// module id = 1410
// module chunks = 0